/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useCallback } from 'react';
import type { OnOtpVerified, OtpFlow } from '../types';
import { useEmailUpdateFlow } from '../../useEmailUpdateFlow';

export interface UseEmailChangeOnPhoneOtpFlowOptions {
  startTimer: () => void;
  onVerified?: OnOtpVerified;
}

export function useEmailChangeOnPhoneOtpFlow({
  startTimer,
  onVerified,
}: UseEmailChangeOnPhoneOtpFlowOptions): OtpFlow {
  const emailUpdateFlow = useEmailUpdateFlow();

  const submitOtp = useCallback(
    (otp: string) => emailUpdateFlow.verifyPhoneOtp(otp, onVerified),
    [emailUpdateFlow, onVerified],
  );

  const requestOtp = useCallback(
    () => emailUpdateFlow.requestPhoneOtp(startTimer, startTimer),
    [emailUpdateFlow, startTimer],
  );

  return {
    submitOtp,
    requestOtp,
    errorMessage: emailUpdateFlow.errorMessage,
    isLoading: emailUpdateFlow.isLoading,
    clearError: emailUpdateFlow.clearError,
  };
}
